// extracted by mini-css-extract-plugin
export default {"mainWrapper":"statsRow_mainWrapper__X5m7I","divider":"statsRow_divider__q5DO4","hrVertical":"statsRow_hrVertical__dHFlD"};